import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import { Link } from "@quintype/components";
import ResponsiveImageWithFallback from "../responsive-image-with-fallback";
import SmallStoryCard from "../small-story-card/index";
import ReadMoreLink from "../read-more-link/index";
import { generateImageSources } from "../../utils/utils";
import { addPagePathtoMagazineIssues } from "../../../data/entity";
import { fetchCollection } from "../../../api";
import styles from "./styles.m.css";

const MagazineMainCard = ({ magazine, className = "", config }) => {
  let mainMagazine = {};
  const magazineSort = magazine.sort(function(a, b) {
    return new Date(get(b.collections, [0, "created-at"])) - new Date(get(a.collections, [0, "created-at"]));
  });
  if (magazineSort) {
    mainMagazine = get(magazineSort.slice(0, 1), [0]);
  }
  const setPathMagazine = addPagePathtoMagazineIssues(mainMagazine, config);
  const pagePath = get(setPathMagazine.collections, [0, "pagePath"], "");
  const coverImageS3Key = get(mainMagazine.collections, [0, "metadata", "cover-image", "cover-image-s3-key"], "");
  const coverImageMetaData = get(mainMagazine.collections, [0, "metadata", "cover-image", "cover-image-metadata"], "");
  const imgAltText = get(mainMagazine.collections, [0, "metadata", "magazine", "name"], "");
  const communityColor = get(mainMagazine, ["color"], "");
  const collectionSlug = get(setPathMagazine.collections, [0, "slug"], "");
  const pageNumber = 2;
  const limit = 2;
  const [stories, setData] = useState([]);
  useEffect(() => {
    fetchCollection(collectionSlug, pageNumber, limit, {}).then(response => setData(response["items"]));
  }, []);
  return (
    <div className={`${styles["base"]} ${className}`} style={{ "--accent-color": communityColor }}>
      <h2>விகடன் இதழ்களில் இப்போது…</h2>
      <div className={styles["image-container"]}>
        <Link aria-label="Magazine" href={`${pagePath}?mfrm=home`}>
          <ResponsiveImageWithFallback
            className={`${styles["image-wrapper"]} qt-figure`}
            slug={coverImageS3Key}
            metadata={coverImageMetaData}
            alt={imgAltText}
            imgParams={{ auto: ["format", "compress"] }}
            sources={generateImageSources(
              { aspectRatio: [3, 4], screenWidthCoverage: 0.95 },
              { aspectRatio: [3, 4], screenWidthCoverage: 0.32 }
            )}
          />
        </Link>
      </div>
      <div className={styles["two-stories-wrap"]}>
        {stories &&
          stories.map(
            story => story && <SmallStoryCard key={story.id} story={story.story} className={styles["story-card"]} />
          )}
      </div>
      <ReadMoreLink className={styles["read-more-buton"]} href={`${pagePath}?mfrm=home`} text={"மேலும் படிக்க"} />
    </div>
  );
};

MagazineMainCard.propTypes = {
  className: PropTypes.string,
  collection: PropTypes.shape(),
  magazine: PropTypes.array,
  config: PropTypes.shape()
};

export default MagazineMainCard;
